(function () {
  if (window.__multiStockTranslateLoaded) return;
  window.__multiStockTranslateLoaded = true;

  const translations = {
    "Switch Location": "Cambiar tienda",
    "Clear Cart & Continue..": "Vaciar carrito y continuar",
    "Clear Cart & Continue...": "Vaciar carrito y continuar",
    "Close": "Cerrar"
  };

  function translateButtons(root = document) {
    const selectors = [
      "button",
      "a",
      "input[type='button']",
      "input[type='submit']"
    ];

    const elements = root.querySelectorAll(selectors.join(","));

    elements.forEach((el) => {
      const text = (el.innerText || el.value || "").trim();

      if (translations[text]) {
        if (el.tagName === "INPUT") {
          el.value = translations[text];
        } else {
          el.innerText = translations[text];
        }
      }
    });
  }

  function runTranslations() {
    try {
      translateButtons(document);
    } catch (e) {
      console.warn("MultiStock translation error:", e);
    }
  }

  document.addEventListener("DOMContentLoaded", runTranslations);

  const observer = new MutationObserver(() => {
    runTranslations();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  setInterval(runTranslations, 1200);
})();